import { useState, useEffect } from 'react';

/**
 * Custom hook to fetch CMS content from API with static fallback
 */
export function useCmsContent(collectionName, fallbackData = []) {
  const [items, setItems] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await fetch(`https://api.dev.auxo.dk/public/content/${collectionName}`);
        if (!res.ok) {
          throw new Error(`CMS status ${res.status}`);
        }
        const data = await res.json();
        if (isMounted && Array.isArray(data) && data.length > 0) {
          setItems(data);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message);
          // Keep fallbackData on error
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [collectionName]);

  return { items, loading, error };
}

/**
 * Scroll restoration hook to scroll to top when route changes
 */
export function useScrollToTop() {
  const { pathname } = window.location;
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
}
